import * as types from "../actionTypes";

export const get = (account_type, pageNumber = null) => {
  return {
    type: types.PETTY_CASHIER_GET_ACCOUNT_REVIEW_REQUEST,
    account_type: account_type,
    pageNumber
  };
};

export const getSuccess = data => {
  return {
    type: types.PETTY_CASHIER_GET_ACCOUNT_REVIEW_SUCCESS,
    payLoad: data
  };
};
export const getFailure = error => {
  return {
    type: types.PETTY_CASHIER_GET_ACCOUNT_REVIEW_FAILURE,
    error: error
  };
};

export const remove = (id, accountType, pageNumber = null) => {
  return {
    type: types.PETTY_CASHIER_REMOVE_ACCOUNT_REVIEW_REQUEST,
    id: id,
    account_type: accountType,
    pageNumber
  };
};

export const removeSuccess = data => {
  return {
    type: types.PETTY_CASHIER_REMOVE_ACCOUNT_REVIEW_SUCCESS,
    payLoad: data
  };
};

export const removeFailure = () => {
  return {
    type: types.PETTY_CASHIER_REMOVE_ACCOUNT_REVIEW_FAILURE
  };
};

export const multiDelete = data => {
  return {
    type: types.MULTI_DELETE_TRANSACTIONS_REQUEST,
    data
  };
};

export const multiDeleteSuccess = () => {
  return {
    type: types.MULTI_DELETE_TRANSACTIONS_SUCCESS
  };
};
export const multiDeleteFailure = () => {
  return {
    type: types.MULTI_DELETE_TRANSACTIONS_FAILURE
  };
};

export const copyToAnotherProject = data => {
  return {
    type: types.PETTY_CASHIER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_REQUEST,
    data
  };
};

export const copyToAnotherProjectSuccess = data => {
  return {
    type: types.PETTY_CASHIER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_SUCCESS,
    payLoad: data
  };
};
export const copyToAnotherProjectFailure = () => {
  return {
    type: types.PETTY_CASHIER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_FAILURE
  };
};
